import AviaLoaderJSON from 'shared/json/loader.json'

export const TypesLoader = {
  avia: {
    file: AviaLoaderJSON,
    key: 'avia',
  },
  excursions: {
    file: AviaLoaderJSON,
    key: 'excursions',
  },
  beket: {
    file: AviaLoaderJSON,
    key: 'beket',
  },
} as const

export const TypesLoaderList = Object.keys(TypesLoader)?.map((key) => ({
  name: TypesLoader[key as keyof typeof TypesLoader].file,
  key: key,
}))

export type LoaderTypes = keyof typeof TypesLoader
